
//jaswantcode
import React, {
    ChangeEvent,
    useCallback,
    useEffect,
    useMemo,
    useState,
    useRef,
} from 'react';
import { FaPuzzlePiece } from "react-icons/fa6";
import { MdOutlineSwipe } from "react-icons/md";
import { TbDragDrop2 } from "react-icons/tb";
import { FaLightbulb } from "react-icons/fa";
import { getCreator } from 'utils/creator/creator';
import { getCompany } from 'utils/company/companyService';
import { HiLink } from 'react-icons/hi';
import { IoAlert } from "react-icons/io5";
import { MdPsychology } from "react-icons/md";
import { FaChartLine } from 'react-icons/fa';
import { FaClipboardList } from 'react-icons/fa';
import { MdAssessment } from "react-icons/md";
import { MdOutlineAssessment } from "react-icons/md";
import InputField from 'components/fields/InputField';
import {
    Box,
    Text,
    Flex,
    Checkbox,
    Button,
    Icon,
    List,
    ListItem,
    Img,
    Textarea,
    Input,
    Divider,
    Switch,
    Tooltip,
    SimpleGrid
} from '@chakra-ui/react';
import Select from 'react-select';
import {
    MdAdd,
    MdCloudUpload,
    MdInbox,
    MdNote,
    MdNoteAdd,
    MdTextsms,
    MdDelete,
    MdOutlineStickyNote2,
} from 'react-icons/md';
import { BiSolidDuplicate } from 'react-icons/bi';
import Menu from '../components/Navigate';
import StrightConector from '../components/dragNdrop/strightConector';

import { TbHandClick, TbMessages } from 'react-icons/tb';
import { FaAward } from 'react-icons/fa6';
import { FileText, Layers, Settings } from 'lucide-react';
import { Tabs, TabsTrigger, TabsList, TabsContent } from '@radix-ui/react-tabs';
interface PropsNote {
    formData?: any;
    showReflectionQuestions?: any;
    reviews?: any;
    id?: number;
    language?: any;
    seq?: any;
    index?: number;
    handleNDI?: any;
    name?: any;
    handleInput?: any;
    input?: any;
    getSeq?: any;
    handleMiniNDI?: any;
    duplicateSeq?: any;
    delSeq?: any;
    alphabet?: any;
    setNavigation: any;
    handleBlock: any;
    items?: any;
    formDataGamelanguageCode?: any;
    handleSelectBlock?: any;
    showSelectBlock?: any;
    setSelectBlock?: any;
    validation?: any;
    currentseq?: any;
    ShowReview?: any;
    targetSequence?: any;
    blockOnFocusHanlder: any;
    blockOnBlurHanlder: any;
}
interface Block {
    blockPrimarySequence: string;
    // Add other properties as needed
    content: string | undefined; // Adjust the type according to your data structure
}
interface GameRound {
    id: number;
    // add more fields later if needed
}

interface GameSettings {
    pointsPerCorrect: number;
    timerEnabled: boolean;
    timePerRound: number;
    allowReplay: boolean;
}

interface WehaveChooseConfig {
    title: string;
    subtitle: string;
    characterName: string;
    topicSubtitle: string;
    rounds: GameRound[];
    settings: GameSettings;
}

type OptionField = "optionText" | "feedback" | "guidance" | "isCorrect";

interface Option {
    optionText: string;
    feedback: string;
    guidance: string;
    isCorrect: boolean;
}

interface Round {
    Statement: string;
    feedback: string;
    correctAnswer: string;
}


const DEFAULT_WEHAVECHOOSE_CONFIG: WehaveChooseConfig = {
    title: "",
    subtitle: "",
    characterName: "",
    topicSubtitle: "",
    rounds: [], // ✅ now typed as GameRound[]
    settings: {
        pointsPerCorrect: 100,
        timerEnabled: false,
        timePerRound: 30,
        allowReplay: false,
    },
};


const SwipeMiniGameCompo: React.FC<PropsNote> = ({
    formData,
    targetSequence,
    showReflectionQuestions,
    seq,
    index,
    name,
    handleInput,
    input,
    getSeq,
    duplicateSeq,
    delSeq,

    setNavigation,
    handleBlock,
    handleSelectBlock,
    items,

    showSelectBlock,
    handleNDI,

    validation,
}) => {
    console.log('inputssss', input);

    // Update scenario options to include API response values
    const getScenarioOptions = useMemo(() => {
        const options = [];
        const blockData = input?.[`SwipeMiniGame${seq.input}`];

        // Add left option if it exists
        if (blockData?.leftOption) {
            options.push({
                label: ` ${blockData.leftOption}`,
                value: blockData.leftOption
            });
        }

        // Add right option if it exists
        if (blockData?.rightOption) {
            options.push({
                label: ` ${blockData.rightOption}`,
                value: blockData.rightOption
            });
        }

        return options;
    }, [input, seq.input]);

    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGame]);

    const customButtonStyles = {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '15px',
        borderColor: '#ccc', // Optional: Change border color for disabled state
        borderWidth: '1px', // Add this line to set the border width
        borderStyle: 'solid', // Add this line to set the border style
        cursor: 'not-allowed', // Optional: Change cursor for disabled state
        padding: '5px 10px',
        width: '144px',
        // textAlign: "left",
        outerWidth: '10px',
        outline: 'none',
    };

    const customStyles = {
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
        control: (provided: any, state: any) => ({
            ...provided,
            borderRadius: '8px',
            borderColor: 'inherit',
            background: 'transparent',
            // height: '45px',
            width: '100%',
            padding: '0 !important',
        }),
    };

    const handleMiniNDInewblock = (value?: any, seq?: any, i?: any) => {
        handleNDI(value);

        const maxInputItem = items.reduce(
            (max: any, item: any) => (item.input > max.input ? item : max),
            items[0],
        );
        let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;
        if (value !== '') {
            handleSelectBlock(
                { value: input },
                input,
                `SwipeMiniGame${seq.input}`,
                `SwipeMiniGame${seq.input}`,
            );
        }
    };

    //  const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);
    // const [showWrongAnswer, setShowWrongAnswer] = React.useState(
    //     !!input?.[`SwipeMiniGame${seq.input}`]?.answerguide
    // );




    const MiniBox1 = (props: {
        seq?: any;
        i?: number;
        name?: any;
        bodyRef?: any;
    }) => {
        const { seq, i, name, bodyRef } = props;
        return (
            <Box
                position={'absolute'}
                background={'#fff'}
                p={'10px'}
                boxShadow={'1px 1px 17px #69627914'}
                borderRadius={'8px'}
                zIndex={99}
                className="MiniShowBox"
            >
                <List cursor={'pointer'}>
                    <ListItem
                        onClick={() => handleMiniNDInewblock('Note', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                    >
                        <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
                        Note
                    </ListItem>

                    <ListItem
                        onClick={() => handleMiniNDInewblock('Dialog', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                    >
                        <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
                        Dialog
                    </ListItem>
                    <ListItem
                        onClick={() => handleMiniNDInewblock('Interaction', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                    >
                        <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
                        Interaction
                    </ListItem>
                    <ListItem
                        onClick={() => handleMiniNDInewblock('Link', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                    >
                        <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
                        Link
                    </ListItem>
                    {showReflectionQuestions && (
                        <>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('Reflection', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
                                Reflection
                            </ListItem>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('Overview', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
                                Overview
                            </ListItem>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('KeyInsights', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
                                KeyInsights
                            </ListItem>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('PreAssessment', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
                                PreAssessment
                            </ListItem>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('PostAssessment', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
                                PostAssessment
                            </ListItem>
                                           <ListItem
                                        onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
                                        p={'10px'}
                                        display={'flex'}
                                        alignItems={'center'}
                                        borderBottom={'2px solid #f1f1f170'}
                                      >
                                        <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
                                        WehaveChoose
                                      </ListItem>
                                                 <ListItem
                                        onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
                                        p={'10px'}
                                        display={'flex'}
                                        alignItems={'center'}
                                        borderBottom={'2px solid #f1f1f170'}
                                      >
                                        <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
                                        Swipe
                                      </ListItem>
                                                 <ListItem
                                        onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
                                        p={'10px'}
                                        display={'flex'}
                                        alignItems={'center'}
                                        borderBottom={'2px solid #f1f1f170'}
                                      >
                                        <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
                                        Drag For Now 
                                      </ListItem>

                            {formData?.gameScenarioCompletion === "true" &&

                                <ListItem
                                    onClick={() => handleMiniNDInewblock('ScenarioCompletion', seq, i)}
                                    p={'10px'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    borderBottom={'2px solid #f1f1f170'}
                                >
                                    <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
                                    ScenarioCompletion
                                </ListItem>
                            }
                        </>
                    )}
                   
                </List>
            </Box>
        );
    };

    const justClick = (event: any, seq: any) => {
        const element = event.target;
        element.focus();
    };

    const createOption = () => ({
        optionText: "",
        feedback: "",
        guidance: "",
        isCorrect: false,
    });

    const createRound = () => ({
        Statement: "",
        feedback: "",
        correctAnswer: "",
    });


    const [rounds, setRounds] = useState<Round[]>([]);

    console.log('rounds:', rounds);
    const [isHydrated, setIsHydrated] = useState(false);

    const weHaveChoose = input?.[`SwipeMiniGame${seq.input}`];
    console.log('dfffrff', weHaveChoose);
    const [replayValue, setReplayValue] = useState<"On" | "Off">("Off");

    const rangeValue = Number(weHaveChoose?.timer ?? 0);

    const rawTimerEnabled = weHaveChoose?.timerEnabled;

    // normalize EVERYTHING to boolean
    // Backend: 1 = enabled, 0 = disabled, null = disabled
    const timerEnabled =
        rawTimerEnabled === true ||
        rawTimerEnabled === "true" ||
        rawTimerEnabled === 1 ||
        rawTimerEnabled === "1";

    const normalizedTimerEnabled = timerEnabled;

    const isInitiallyDisabled =
        rawTimerEnabled === false ||
        rawTimerEnabled === "false" ||
        rawTimerEnabled === 0 ||
        rawTimerEnabled === "0" ||
        rawTimerEnabled == null;

    const [timerUnlocked, setTimerUnlocked] = useState(false);
    const isSwitchDisabled = isInitiallyDisabled && !timerUnlocked;
    const isSwitchChecked = normalizedTimerEnabled;
    const rangeEnabled = normalizedTimerEnabled;

    const rawAnswerGuideEnabled =
        weHaveChoose?.answerGuideEnabled;

    // normalize EVERYTHING to boolean
    // Backend: 1 = enabled, 0 = disabled, null = disabled
    const isAnswerGuideEnabled =
        rawAnswerGuideEnabled === true ||
        rawAnswerGuideEnabled === "true" ||
        rawAnswerGuideEnabled === 1 ||
        rawAnswerGuideEnabled === "1";

    useEffect(() => {
        if (weHaveChoose?.ShowReplay === "On" || weHaveChoose?.ShowReplay === "Off") {
            setReplayValue(weHaveChoose.ShowReplay);
        }
    }, [weHaveChoose?.ShowReplay]);


    const addRound = () => {
        setRounds(prev => [...prev, createRound()]);
    };

    type RoundField = "Statement" | "feedback" | "correctAnswer";

    const updateRound = (
        roundIndex: number,
        field: RoundField,
        value: string
    ) => {
        setRounds(prev => {
            const copy = [...prev];
            copy[roundIndex] = {
                ...copy[roundIndex],
                [field]: value,
            };
            return copy;
        });
    };








    const deleteRound = (roundIndex: number) => {
        setRounds((prev) => {
            if (prev.length <= 1) return prev;
            return prev.filter((_, i) => i !== roundIndex);
        });
    };





    useEffect(() => {
        const blockData = input?.[`SwipeMiniGame${seq.input}`];
        if (!blockData || isHydrated) return;

        const parsed = safeParseJSON(blockData.roundLogic);

        if (parsed) {
            const uiRounds = convertRoundLogicToRounds(parsed);
            setRounds(uiRounds.length ? uiRounds : [createRound()]);
        } else {
            setRounds([createRound()]);
        }

        setIsHydrated(true);
    }, [input, seq?.input, isHydrated]);




    const buildRoundLogicPayload = (rounds: Round[]) => {
        const payload: any = {};

        rounds.forEach((round, index) => {
            payload[`round${index + 1}`] = {
                Statement: round.Statement,
                feedback: round.feedback,
                correctAnswer: round.correctAnswer,
            };
        });

        return payload;
    };





    useEffect(() => {
        if (!isHydrated) return;

        handleInput({
            target: {
                name: `SwipeMiniGame${seq.input}`,
                id: "roundLogic",
                value: buildRoundLogicPayload(rounds),
            },
        });
    }, [rounds, isHydrated]);




    const safeParseJSON = (value: any) => {
        if (!value) return null;

        if (typeof value === "object") return value;

        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            } catch (err) {
                console.error("Invalid roundLogic JSON", err);
                return null;
            }
        }

        return null;
    };

    const convertRoundLogicToRounds = (roundLogic: any): Round[] => {
        if (!roundLogic || typeof roundLogic !== "object") return [];

        return Object.values(roundLogic).map((round: any) => ({
            Statement: round.Statement || "",
            feedback: round.feedback || "",
            correctAnswer: round.correctAnswer || "",
        }));
    };


    const backendReplay = weHaveChoose?.ShowReplay;
    // normalize EVERYTHING to boolean
    // Backend: true = enabled, false = disabled, "On"/"Off" = legacy, null = disabled
    const isReplayChecked =
        backendReplay === true ||
        backendReplay === "On" ||
        backendReplay === 1 ||
        backendReplay === "1";



    return (
        <Flex padding={'10px 0'} alignItems={'start'} overflowY={'hidden'}>
            <Box className="block-action-icons">
                <Tooltip hasArrow label="Choose New Block">
                    <div>
                        <Icon
                            as={MdAdd}
                            transitionDelay={'0s !important'}
                            fontSize={'18px'}
                            color={'grey'}
                            mr={'10px'}
                            cursor={'pointer'}
                            onClick={() => getSeq(seq, index, name)}
                        />
                    </div>
                </Tooltip>
                <Tooltip hasArrow label="Duplicate">
                    <div>
                        <Icon
                            as={BiSolidDuplicate}
                            transitionDelay={'0.1s !important'}
                            fontSize={'18px'}
                            color={'grey'}
                            mr={'10px'}
                            cursor={'pointer'}
                            onClick={() =>
                                duplicateSeq(seq, index, name, input?.[`SwipeMiniGame${seq.input}`])
                            }
                        />
                    </div>
                </Tooltip>
                <Tooltip hasArrow label="Delete SwipeMiniGame">
                    <div>
                        <Icon
                            as={MdDelete}
                            transitionDelay={'0.2s !important'}
                            fontSize={'18px'}
                            color={'grey'}
                            cursor={'pointer'}
                            onClick={() => delSeq(seq, index, name)}
                        />
                    </div>
                </Tooltip>
            </Box>
            <Box
                className="block-id"
                mr={'10px'}
                w={'50px'}
                fontSize={'17px'}
                color={'#1b2559'}
                fontWeight={'700'}
            >
                {seq.id}
            </Box>

            {/* <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={1} > */}
            {/* title */}

            <div className='flex self-stretch flex-row flex-1 w-full'>
                <Tabs defaultValue="general" className="h-full flex self-stretch w-full flex flex-col">

                    <TabsList className="flex w-full items-center">
                        <TabsTrigger value="general"
                            className="flex flex-1 items-center px-4 py-2 gap-2 text-slate-600 transition-all duration-200 data-[state=active]:shadow-md data-[state=active]:rounded-md data-[state=active]:bg-white data-[state=active]:text-slate-900">
                            <div className='flex flex-1 items-center justify-center px-4 py-2 gap-2'>
                                <FileText className="h-4 w-4" />
                                General Info
                            </div>
                        </TabsTrigger>
                        <TabsTrigger value="rounds"
                            className="flex flex-1 items-center px-4 py-2 gap-2 text-slate-600 transition-all duration-200 data-[state=active]:shadow-md data-[state=active]:rounded-md data-[state=active]:bg-white data-[state=active]:text-slate-900">
                            <div className='flex flex-1 items-center justify-center px-4 py-2 gap-2'>
                                <Layers className="h-4 w-4" />
                                Rounds & Questions
                            </div>
                        </TabsTrigger>
                        <TabsTrigger value="settings"
                            className="flex flex-1 items-center px-4 py-2 gap-2 text-slate-600 transition-all duration-200 data-[state=active]:shadow-md data-[state=active]:rounded-md data-[state=active]:bg-white data-[state=active]:text-slate-900">
                            <div className='flex flex-1 items-center justify-center px-4 py-2 gap-2'>
                                <Settings className="h-4 w-4" />
                                Settings
                            </div>
                        </TabsTrigger>
                    </TabsList>

                    <TabsContent value="general" className="flex flex-1 mt-[20px] gap-4 self-stretch flex-col">

                        {/* <Box className=''> */}
                        <Box className="title" w="full" display="flex" >
                            <input
                                placeholder="Title"
                                id="MiniTitle"
                                className={` ${seq.id}`}
                                name={`SwipeMiniGame${seq.input}`}
                                onChange={handleInput}
                                onClick={(e: any) => justClick(e, seq)}
                                value={input?.[`SwipeMiniGame${seq.input}`]?.MiniTitle || ''}
                                style={{
                                    overflow: 'hidden',
                                    border: validation?.[`SwipeMiniGame${seq.input}`]
                                        ? '2px solid red'
                                        : '1px solid #cbd5e1',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    outline: 'none',
                                    width: '100%',
                                }}
                            />
                        </Box>

                        {/* subtitle */}
                        <Box className="block-input-text" display="flex" w="full" >

                            <textarea
                                ref={textareaRef}
                                placeholder="Subtitle"
                                id="SwipeMiniGame"
                                className={`${seq.id}`}
                                name={`SwipeMiniGame${seq.input}`}
                                onChange={handleInput}
                                onClick={(e) => justClick(e, seq)}
                                value={input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGame || ''}
                                style={{
                                    overflow: 'hidden',
                                    border: validation?.[`SwipeMiniGame${seq.input}`]
                                        ? '2px solid red'
                                        : '1px solid #cbd5e1', // default border color
                                    borderRadius: '8px', // ✅ border radius
                                    padding: '8px 12px',
                                    outline: 'none',
                                    width: '100%',
                                }}
                                tabIndex={0}
                            />

                        </Box>

                        {/*   left optiion */}
                        <Box className="Topic" w="full" display="flex" >
                            <div className='flex flex-col w-full'>
                                <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                    Left Option
                                </Text>

                                <input
                                    placeholder="Weak"
                                    id="leftOption"
                                    className={`${seq.id}`}
                                    name={`SwipeMiniGame${seq.input}`}
                                    onChange={handleInput}
                                    onClick={(e: any) => justClick(e, seq)}
                                    value={input?.[`SwipeMiniGame${seq.input}`]?.leftOption || ''}
                                    style={{
                                        overflow: 'hidden',
                                        border: validation?.[`SwipeMiniGame${seq.input}`]
                                            ? '2px solid red'
                                            : '1px solid #cbd5e1', // default border color
                                        borderRadius: '8px', // ✅ border radius
                                        padding: '8px 12px',
                                        outline: 'none',
                                        width: '100%',
                                    }}
                                />
                            </div>
                        </Box>

                        {/* right option */}
                        <Box className="characterSubtitle" display="flex" w="full" >
                            <div className='flex flex-col w-full'>
                                <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                    Right Option
                                </Text>

                                <input
                                    placeholder="Strong"
                                    id="rightOption"
                                    className={`${seq.id}`}
                                    name={`SwipeMiniGame${seq.input}`}
                                    onChange={handleInput}
                                    onClick={(e: any) => justClick(e, seq)}
                                    value={input?.[`SwipeMiniGame${seq.input}`]?.rightOption || ''}
                                    style={{
                                        overflow: 'hidden',
                                        border: validation?.[`SwipeMiniGame${seq.input}`]
                                            ? '2px solid red'
                                            : '1px solid #cbd5e1', // default border color
                                        borderRadius: '8px', // ✅ border radius
                                        padding: '8px 12px',
                                        outline: 'none',
                                        width: '100%',
                                    }}
                                />
                            </div>
                        </Box>

                        {/* Instruction Text */}
                        <Box className="characterSubtitle" display="flex" w="full" >
                            <div className='flex flex-col w-full'>
                                <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                    Instruction Text
                                </Text>

                                <input
                                    placeholder="Instruction Text"
                                    id="instructionText"
                                    className={`${seq.id}`}
                                    name={`SwipeMiniGame${seq.input}`}
                                    onChange={handleInput}
                                    onClick={(e: any) => justClick(e, seq)}
                                    value={input?.[`SwipeMiniGame${seq.input}`]?.instructionText || ''}
                                    style={{
                                        overflow: 'hidden',
                                        border: validation?.[`SwipeMiniGame${seq.input}`]
                                            ? '2px solid red'
                                            : '1px solid #cbd5e1', // default border color
                                        borderRadius: '8px', // ✅ border radius
                                        padding: '8px 12px',
                                        outline: 'none',
                                        width: '100%',
                                    }}
                                />
                            </div>
                        </Box>

                        {/* Statement Label */}
                        <Box className="characterSubtitle" display="flex" w="full" >
                            <div className='flex flex-col w-full'>
                                <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                    Statement Label
                                </Text>

                                <input
                                    placeholder="Statement Label"
                                    id="statementLabel"
                                    className={`${seq.id}`}
                                    name={`SwipeMiniGame${seq.input}`}
                                    onChange={handleInput}
                                    onClick={(e: any) => justClick(e, seq)}
                                    value={input?.[`SwipeMiniGame${seq.input}`]?.statementLabel || ''}
                                    style={{
                                        overflow: 'hidden',
                                        border: validation?.[`SwipeMiniGame${seq.input}`]
                                            ? '2px solid red'
                                            : '1px solid #cbd5e1', // default border color
                                        borderRadius: '8px', // ✅ border radius
                                        padding: '8px 12px',
                                        outline: 'none',
                                        width: '100%',
                                    }}
                                />
                            </div>
                        </Box>
                        {/* </Box> */}

                    </TabsContent>

                    {/* scanrio */}
                    {/* <Box
                    className="scenario-dropdown"
                    mb="10px"
                    w={{ base: '100%', lg: '200px' }}
                >
                    <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                        Select Scenario
                    </Text>

                    <Select
                        placeholder="Select Scenario"
                        options={getScenarioOptions}
                        // value={input?.[`Note${seq.input}`]?.scenario || null}

                        value={
                            getScenarioOptions.find(
                                (opt) =>
                                    opt.value === input?.[`SwipeMiniGame${seq.input}`]?.scenario
                            ) || null
                        }
                        styles={{
                            ...customStyles,
                            control: (provided: any) => ({
                                ...provided,
                                borderRadius: '12px',
                                minHeight: '36px',
                            }),
                        }}
                        onChange={(option: any) =>
                            handleInput({
                                name: `SwipeMiniGame${seq.input}`,
                                value: {
                                    // scenario: option,
                                    scenario: option?.value,

                                },
                            })
                        }
                        isSearchable={false}
                        menuPortalTarget={document.body}
                    />
                </Box> */}

                    <TabsContent value="settings" className='flex flex-col gap-4 mt-[20px] self-stretch' >
                        {/* score */}
                        <Box className="score" mb="10px" display="flex" w={200} >
                            <div className='flex flex-col w-full'>
                                <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                    Points per Correct Answer
                                </Text>
                                <input
                                    placeholder="Score"
                                    type='number'
                                    id="PointsPerCorrectScore"
                                    className={`${seq.id}`}
                                    name={`SwipeMiniGame${seq.input}`}
                                    onChange={handleInput}
                                    onClick={(e: any) => justClick(e, seq)}
                                    value={input?.[`SwipeMiniGame${seq.input}`]?.PointsPerCorrectScore || ''}
                                    style={{
                                        overflow: 'hidden',
                                        border: validation?.[`SwipeMiniGame${seq.input}`]
                                            ? '2px solid red'
                                            : '1px solid #cbd5e1', // default border color
                                        borderRadius: '8px', // ✅ border radius
                                        padding: '8px 12px',
                                        outline: 'none',
                                    }}
                                />
                            </div>
                        </Box>


                        <div className='flex self-stretch gap-4 w-full '>
                            {/* correct answer */}
                            <Box className="score flex-1">
                                <div className='flex flex-col w-full'>
                                    <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                        Correct Answer
                                    </Text>
                                    <input
                                        placeholder="Correct answer"
                                        id="CorrectAnswerFeedback"
                                        className={`${seq.id}`}
                                        name={`SwipeMiniGame${seq.input}`}
                                        onChange={handleInput}
                                        onClick={(e: any) => justClick(e, seq)}
                                        value={input?.[`SwipeMiniGame${seq.input}`]?.CorrectAnswerFeedback || ''}
                                        style={{
                                            overflow: 'hidden',
                                            border: validation?.[`SwipeMiniGame${seq.input}`]
                                                ? '2px solid red'
                                                : '1px solid #cbd5e1', // default border color
                                            borderRadius: '8px', // ✅ border radius
                                            padding: '8px 12px',
                                            outline: 'none',
                                        }}
                                    />
                                </div>
                            </Box>
                            {/* wrong answer */}
                            <Box className="score flex-1">
                                <div className='flex flex-col w-full'>
                                    <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                        Wrong Answer
                                    </Text>

                                    <input
                                        placeholder="Wrong answer"
                                        id="WrongAnswerFeedback"
                                        className={`${seq.id}`}
                                        name={`SwipeMiniGame${seq.input}`}
                                        onChange={handleInput}
                                        onClick={(e: any) => justClick(e, seq)}
                                        value={input?.[`SwipeMiniGame${seq.input}`]?.WrongAnswerFeedback || ''}
                                        style={{
                                            overflow: 'hidden',
                                            border: validation?.[`SwipeMiniGame${seq.input}`]
                                                ? '2px solid red'
                                                : '1px solid #cbd5e1', // default border color
                                            borderRadius: '8px', // ✅ border radius
                                            padding: '8px 12px',
                                            outline: 'none',
                                        }}
                                    />
                                </div>
                            </Box>
                        </div>

                        {/* range meter */}


                        {/* Label + Switch */}
                        <div className="flex items-center justify-between "

                            onClick={() => {
                                // unlock on first interaction
                                if (isSwitchDisabled) {
                                    setTimerUnlocked(true);

                                    handleInput({
                                        target: {
                                            id: "timerEnabled",
                                            name: `SwipeMiniGame${seq.input}`,
                                            value: true, // first enable
                                        },
                                    });
                                }
                            }}
                        >
                            <p className="text-[13px] font-semibold text-[#1b2559]">
                                Enable Timer
                            </p>
                            <Switch
                                isChecked={isSwitchChecked}
                                isDisabled={isSwitchDisabled}
                                pointerEvents={isSwitchDisabled ? "none" : "auto"}
                                className='mr-[10px]'
                                onChange={(e) =>
                                    handleInput({
                                        target: {
                                            id: "timerEnabled",
                                            name: `SwipeMiniGame${seq.input}`,
                                            value: e.target.checked, // boolean
                                        },
                                    })
                                }
                            />

                        </div>

                        <div className='flex gap-4'>
                            <p className="text-[13px] font-semibold text-[#1b2559]">
                                Time Per Round
                            </p>
                            <p className="text-xs text-muted-foreground text-right">
                                {input?.[`SwipeMiniGame${seq.input}`]?.Timerlimit ?? 0}
                            </p>
                        </div>
                        {/* Range Slider */}

                        {rangeEnabled && ( 
                           
                        <div className="space-y-1 w-full">
                            <input
                                type="range"
                                min={0}
                                max={120}
                                className='w-full flex flex-1'
                                value={Number(weHaveChoose?.Timerlimit ?? 0)}
                                onChange={(e) =>
                                    handleInput({
                                        target: {
                                            id: "Timerlimit",
                                            name: `SwipeMiniGame${seq.input}`,
                                            value: Number(e.target.value),
                                        },
                                    })
                                }
                            />
                            {/* Optional value display */}

                        </div>
                         )}

                        {/* replay */}
                        <div className="flex items-center justify-between ">
                            <p className="text-[13px] font-semibold text-[#1b2559]">
                                Allow Replay
                            </p>

                            <div className='flex gap-4 mr-[10px] '>
                                <Text fontSize="12px" fontWeight="600" color={isReplayChecked ? "green.500" : "red.500"} >
                                    {isReplayChecked ? "Replay Enabled" : "Replay Disabled"}
                                </Text>
                                <Switch
                                    id="ShowReplay"
                                    isChecked={weHaveChoose?.ShowReplay === 1 || weHaveChoose?.ShowReplay === 1}
                                    onChange={(e) => {
                                        handleInput({
                                            target: {
                                                name: `SwipeMiniGame${seq.input}`,
                                                id: "ShowReplay",
                                                value: e.target.checked,
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        {/* Streak Messages */}
                        <Box className="score flex flex-col gap-3 ">
                            <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                Streak Messages (Optional)
                            </Text>
                            {/* <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559" style={{ marginTop: '10px' }}>
                      Messages shown for consecutive correct answers. Streaks trigger at 2, 3, 4, and 5 correct answers in a row.
                    </Text> */}

                            <div className='flex flex-col gap-2'>
                                <div className='w-full flex gap-4'>
                                    <div className='flex flex-col flex-1 self-stretch'>
                                        <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                            2-Streak
                                        </Text>

                                        <input
                                            placeholder=" 2-Streak"
                                            type='text'
                                            id="Streak2message"
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Streak2message || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>

                                    <div className='flex flex-col flex-1 self-stretch'>
                                        <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                            3-Streak
                                        </Text>

                                        <input
                                            placeholder=" 3-Streak"
                                            type='text'
                                            id="Streak3message"
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Streak3message || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='w-full flex gap-4'>
                                    <div className='flex flex-col flex-1 self-stretch'>
                                        <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                            4-Streak
                                        </Text>

                                        <input
                                            type='text'
                                            placeholder="4-Streak"
                                            id="Streak4message"
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Streak4message || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1', // default border color
                                                borderRadius: '8px', // ✅ border radius
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>

                                    <div className='flex flex-col flex-1 self-stretch'>
                                        <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                            4-Streak
                                        </Text>

                                        <input
                                            type='text'
                                            placeholder="5-Streak"
                                            id="Streak5message"
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Streak5message || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1', // default border color
                                                borderRadius: '8px', // ✅ border radius
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Box>
                        {/* congratulation message */}
                        {/* low score */}

                        <div className='flex flex-col gap-3'>
                            <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                Congratulatory Message
                            </Text>

                            <Box className="score flex flex-col gap-2">

                                <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                    Low Score
                                </Text>

                                <div className='flex gap-4'>
                                    <div className='flex flex-col flex-1' >
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                            Min %
                                        </Text>

                                        <input
                                            placeholder="Min Score"
                                            type='number'
                                            id="Minlowscore"
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Minlowscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                    <div className='flex flex-col flex-1' >
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                            Max %
                                        </Text>

                                        <input
                                            placeholder="Max Score"
                                            type='number'
                                            id="Maxlowscore"
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Maxlowscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className='flex flex-1 w-full flex-col'>
                                    <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                        Message
                                    </Text>

                                    <input
                                        placeholder="Message"
                                        id="LowScoreMessage"
                                        className={`${seq.id}`}
                                        name={`SwipeMiniGame${seq.input}`}
                                        onChange={handleInput}
                                        onClick={(e: any) => justClick(e, seq)}
                                        value={input?.[`SwipeMiniGame${seq.input}`]?.LowScoreMessage || ''}
                                        style={{
                                            overflow: 'hidden',
                                            border: validation?.[`SwipeMiniGame${seq.input}`]
                                                ? '2px solid red'
                                                : '1px solid #cbd5e1', // default border color
                                            borderRadius: '8px', // ✅ border radius
                                            padding: '8px 12px',
                                            outline: 'none',
                                        }}
                                    />
                                </div>

                            </Box>

                            {/* medium Score */}
                            <Box className="score flex flex-col gap-2">

                                <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                    Medium Score
                                </Text>

                                <div className='flex gap-4'>
                                    <div className='flex flex-col flex-1' >
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                            Min %
                                        </Text>
                                        <input
                                            placeholder="Min Score"
                                            id="Minmediumscore"
                                            type='number'
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Minmediumscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                    <div className='flex flex-col flex-1' >
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                            Max %
                                        </Text>
                                        <input
                                            type='number'
                                            placeholder="Max Score"
                                            id="Maxmediumscore"
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Maxmediumscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className='flex flex-1 w-full flex-col'>
                                    <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                        Message
                                    </Text>

                                    <input
                                        placeholder="Message"
                                        id="MediumScoreMessage"
                                        className={`${seq.id}`}
                                        name={`SwipeMiniGame${seq.input}`}
                                        onChange={handleInput}
                                        onClick={(e: any) => justClick(e, seq)}
                                        value={input?.[`SwipeMiniGame${seq.input}`]?.MediumScoreMessage || ''}
                                        style={{
                                            overflow: 'hidden',
                                            border: validation?.[`SwipeMiniGame${seq.input}`]
                                                ? '2px solid red'
                                                : '1px solid #cbd5e1', // default border color
                                            borderRadius: '8px', // ✅ border radius
                                            padding: '8px 12px',
                                            outline: 'none',
                                        }}
                                    />
                                </div>
                            </Box>

                            {/* High Score */}
                            <Box className="score flex flex-col gap-2">
                                <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                    High Score
                                </Text>
                                <div className='flex gap-4'>
                                    <div className='flex flex-col flex-1'>
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                            Min %
                                        </Text>

                                        <input
                                            placeholder="Min Score"
                                            type='number'
                                            id="Minhighscore"
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Minhighscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                    <div className='flex flex-col flex-1'>
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                            Max %
                                        </Text>

                                        <input
                                            placeholder="Max Score"
                                            type='number'
                                            id="Maxhighscore"
                                            className={`${seq.id}`}
                                            name={`SwipeMiniGame${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`SwipeMiniGame${seq.input}`]?.Maxhighscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='flex flex-1 w-full flex-col'>
                                    <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                        Message
                                    </Text>
                                    <input
                                        placeholder="Message"
                                        id="highScoreMessage"
                                        className={`${seq.id}`}
                                        name={`SwipeMiniGame${seq.input}`}
                                        onChange={handleInput}
                                        onClick={(e: any) => justClick(e, seq)}
                                        value={input?.[`SwipeMiniGame${seq.input}`]?.highScoreMessage || ''}
                                        style={{
                                            overflow: 'hidden',
                                            border: validation?.[`SwipeMiniGame${seq.input}`]
                                                ? '2px solid red'
                                                : '1px solid #cbd5e1', // default border color
                                            borderRadius: '8px', // ✅ border radius
                                            padding: '8px 12px',
                                            outline: 'none',
                                        }}
                                    />
                                </div>
                            </Box>
                        </div>
                    </TabsContent>

                    {/* ================= ROUNDS LOGIC ================= */}
                    <TabsContent value="rounds" className="flex flex-col gap-4 mt-[20px] self-stretch">
                        <Box>

                            <Flex justify="space-between" align="center" mb={4}>
                                <Text fontSize="16px" fontWeight="700">
                                    Rounds ({rounds.length})
                                </Text>

                                <Button size="sm" colorScheme="blue" onClick={addRound}>
                                    + Add Round
                                </Button>
                            </Flex>

                            {rounds.map((round, rIndex) => (
                                <Box
                                    key={rIndex}
                                    border="1px solid #e2e8f0"
                                    borderRadius="10px"
                                    p={4}
                                    mb={5}
                                >
                                    <Flex justify="space-between" align="center" mb={3}>
                                        <Text fontWeight="600">Round {rIndex + 1}</Text>

                                        <Button
                                            size="xs"
                                            colorScheme="red"
                                            variant="outline"
                                            onClick={() => deleteRound(rIndex)}
                                            isDisabled={rounds.length === 1}
                                        >
                                            Delete Round
                                        </Button>
                                    </Flex>


                                    {/* statement */}
                                    <Box mb={3}>
                                        <Text fontSize="13px" fontWeight="600" mb="4px">
                                            Statement
                                        </Text>
                                        <textarea
                                            value={round.Statement}
                                            onChange={(e) =>
                                                updateRound(rIndex, "Statement", e.target.value)
                                            }
                                            className="w-full rounded-lg border px-3 py-2"
                                            placeholder="e.g. Goal: By the end of this quarter, I will achieve 30%..."
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </Box>

                                    {/* feedback */}
                                    <Box mb={4}>
                                        <Text fontSize="13px" fontWeight="600" mb="4px">
                                            Feedback
                                        </Text>
                                        <input
                                            value={round.feedback}
                                            onChange={(e) => updateRound(rIndex, "feedback", e.target.value)}
                                            className="w-full rounded-lg border px-3 py-2"
                                            placeholder="e.g. Is anything amiss in this goal?"
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`SwipeMiniGame${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </Box>

                                    {/* Correct Answer */}
                                    <Box className="scenario-dropdown" mb="10px" >
                                        <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                            Correct Answer
                                        </Text>


                                        {/* <Select
                                    placeholder="Select Correct Answer"
                                    options={getScenarioOptions}
                                    value={
                                        getScenarioOptions.find(
                                            opt =>
                                                opt.value ===
                                                rounds[rIndex]?.options.find(o => o.isCorrect)?.optionText
                                        ) || null
                                    }
                                    styles={customStyles}
                                    onChange={(option: any) => {
                                        if (!option) return;

                                        setRounds(prev => {
                                            const copy = [...prev];
                                            copy[rIndex].options = copy[rIndex].options.map(opt => ({
                                                ...opt,
                                                isCorrect: opt.optionText === option.value,
                                            }));
                                            return copy;
                                        });
                                    }}
                                    isSearchable={false}
                                /> */}
                                        <Select
                                            placeholder="Select Correct Answer"
                                            options={getScenarioOptions}
                                            value={
                                                getScenarioOptions.find(
                                                    opt => opt.value === rounds[rIndex].correctAnswer
                                                ) || null
                                            }
                                            styles={customStyles}
                                            onChange={(option: any) => {
                                                if (!option) return;
                                                updateRound(rIndex, "correctAnswer", option.value);
                                            }}
                                            isSearchable={false}
                                        />


                                    </Box>
                                </Box>
                            ))}

                        </Box>
                    </TabsContent>

                    {/* navigation */}
                    <Box className="navigation-icon justify-center items-center" display={'flex'} alignItems={'center'} mt={'20px'} width={'auto'} >
                        <Flex>
                            <Box>
                                <Tooltip hasArrow label="Add Navigations">
                                    <div>
                                        <Menu
                                            tabState={'leadDialog'}
                                            id={seq.input}
                                            for={`SwipeMiniGame${seq.input}`}
                                            setNavigation={setNavigation}
                                            handleBlock={handleBlock}
                                            items={items}
                                            seq={seq}
                                        />
                                    </div>
                                </Tooltip>
                            </Box>
                            <Box
                                ml={'4px'}
                                cursor={'pointer'}
                                display={
                                    input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGameleadShow ? 'block' : 'none'
                                }
                                zIndex={9999}
                            >
                                {input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGameleadShow === 'New Block' &&
                                    !input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGamenavigate ? (
                                    // Render content for New Block
                                    <>
                                        <MiniBox1 seq={seq} i={index} />
                                    </>
                                ) : input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGameleadShow ===
                                    'Select Block' &&
                                    !input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGamenavigate ? (
                                    // Render select tag for Select Block
                                    <Select
                                        placeholder={'Blocks...'}
                                        id="Dialog"
                                        name={`SwipeMiniGame${seq.input}`}
                                        menuPortalTarget={document.body}
                                        styles={customStyles}
                                        options={showSelectBlock.filter(
                                            (option: any) => option.value !== seq.input,
                                        )}
                                        isSearchable={true}
                                        className="react-select"
                                        value={
                                            showSelectBlock.find(
                                                (option: any) =>
                                                    option.value ==
                                                    input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGamenavigate,
                                            ) || null
                                        }
                                        onChange={(e: any) =>
                                            handleSelectBlock(
                                                e,
                                                seq.input,
                                                `SwipeMiniGame${seq.input}`,
                                                `SwipeMiniGame${seq.input}`,
                                            )
                                        }
                                    />
                                ) : (
                                    // Render content for the 'else' condition
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <StrightConector
                                                name={
                                                    input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGameleadShow ===
                                                        'New Block'
                                                        ? showSelectBlock.find(
                                                            (option: any) =>
                                                                option.value ==
                                                                input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGamenavigate,
                                                        )?.label
                                                        : input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGameleadShow ===
                                                            'Select Block'
                                                            ? showSelectBlock.find(
                                                                (option: any) =>
                                                                    option.value ==
                                                                    input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGamenavigate,
                                                            )?.label
                                                            : input?.[`SwipeMiniGame${seq.input}`]?.SwipeMiniGamenavigate
                                                }
                                            />
                                        </div>
                                    </>
                                )}
                            </Box>
                        </Flex>
                    </Box>
                    {/* </SimpleGrid> */}
                </Tabs>
            </div>
        </Flex>
    );
};

export default SwipeMiniGameCompo;

